export default __webpack_public_path__ + "58f28791d74d5160533c30672b5beef3.svg";